<nav class="w-100 navbar-third"
  (clickOutside)="onNavbarClose()"
  [clickOutsideExclude]="'.messages-modal, .nav-link, nav'"
  [style.top.px]="resizeObserver.getCurrentValue().navbarBorderBox?.height || 0"
>
  <div class="nav-wrapper">
    <div class="bg-gray-200">
      <app-loader #menuItemsLoader />
      @if (!menuItemsLoader.loading) {
      <div class="container-xxl mw-xs-xl-1280p">
        <div class="row navbar-row px-md-4 py-3">
          <div
            class="py-3 px-0 overflow-x-hidden overflow-y-auto"
            [class]="isDetailsBlockHidden ? 'col' : 'col-9'"
          >
            @if (parentElement.id === CatalogueRouteType.CATEGORY) {
              <ng-container *rerender="elements">
                <ngx-masonry [options]="{'animations': {}}" class="categories-scroll-container">
                  @for (el of elements; track el; let i = $index) {
                    @let elementUrl = `/${catalogueRoutePaths.ROOT}/${catalogueRoutePaths.CATEGORY}/${el.slug}`;
                    <div
                      ngxMasonryItem
                      class="masonry-item mb-4 col-4 col-xl-3"
                      [class.small-screen]="smallScreen"
                    >
                      <ng-container *ngTemplateOutlet="categoryMasonryItemOutlet; context: {
                        el: el,
                        elementUrl: elementUrl,
                        highlightedElement: highlightedElement,
                        currentUrlWithoutParams: currentUrlWithoutParams,
                        navigationQueryParams: navigationQueryParams,
                      }"/>
                    </div>
                  }
                </ngx-masonry>
              </ng-container>
            }
            @else {
              @if (parentElement.id === CatalogueRouteType.SYSTEMS) {
                <div class="d-flex gap-3 color-black mb-4">
                  <div
                    class="hover-color-primary cursor-pointer font-secondary"
                    [class.color-primary]="!systemElementsFilter"
                    (click)="setFilter()"
                  >
                    {{ 'NAVBAR.CATALOGUE.ALL_SYSTEMS' | translate }}
                  </div>
                  @for (el of letterIndex; track el) {
                    @let isLetterInactive = inactiveLetters.includes(el);
                    <div
                      class="font-secondary"
                      [class]="{
                        'hover-color-primary': !isLetterInactive,
                        'cursor-pointer': !isLetterInactive,
                        'cursor-not-allowed': isLetterInactive,
                        'color-gray-600': isLetterInactive,
                        'color-primary': systemElementsFilter === el
                      }"
                      (click)="isLetterInactive ? null : setFilter(el)"
                    >
                      {{ el | titlecase }}
                    </div>
                  }
                </div>
              }

              <div class="scroll-container overflow-x-hidden overflow-y-auto">
                @for (el of filteredSystemElements; track el.id; let i = $index) {
                  @let elementBaseUrl = `/${catalogueRoutePaths.ROOT}/${parentElement.id === CatalogueRouteType.SYSTEMS
                  ? catalogueRoutePaths.SYSTEMS
                  : catalogueRoutePaths.COMPONENTS}`;

                  @let elementUrl = `${elementBaseUrl}/${el.slug}`;
                  <div
                    class="masonry-item mb-4 col-12 color-black"
                  >
                    @if (parentElement.id === CatalogueRouteType.COMPONENTS) {
                      <a
                        class="d-flex align-items-center hover-color-primary mb-2 pe-2 border-bottom border-color-gray-400 h2 g-2.5r"
                        [routerLink]="elementUrl"
                      >
                        <span>
                          {{ el.isNameModified ? el.name : (el.name | titlecase) }}
                        </span>
                      </a>
                    } @else {
                      <a
                        class="d-flex align-items-center hover-color-primary mb-2 pe-2 border-bottom border-color-gray-400 h2 g-2.5r"
                        [href]="elementUrl"
                        (click)="$event.preventDefault(); setFilter(el.name)"
                      >
                        <span>
                          {{ el.isNameModified ? el.name : (el.name | titlecase) }}
                        </span>
                      </a>
                    }

                    <div class="row">
                        @let colCount = smallScreen ? 3 : 4;

                        @for (col of [].constructor(colCount); track $index) {
                          <div class="column col-4 col-xl-3" [class]="`columns-${colCount}`">
                            @for (child of getColumnItems($index, colCount, el.children); track $index) {
                              @let childUrl = `${elementUrl}/${child.slug}`;
                              <div
                                class="mb-2 co-l-4 co-l-xl-3 color-black"
                              >
                                <a
                                  class="mb-2 hover-color-primary small"
                                  [routerLink]="childUrl"
                                  [queryParams]="navigationQueryParams"
                                  [class.color-black]="childUrl !== currentUrlWithoutParams"
                                  (click)="onNavbarClose()"
                                  [id]="child.id"
                                  (mouseenter)="onMouseEnter(child)"
                                  (mouseleave)="onMouseLeave()"
                                >
                                  {{ child.isNameModified ? child.name : (child.name | titlecase) }}
                                </a>
                                @if (child.tag) {
                                  <span class="tag text-break d-inline-block text-center color-gray-600">
                                    {{ child.tag }}
                                  </span>
                                }
                              </div>
                            }
                          </div>
                        }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          @if (!isDetailsBlockHidden) {
            <div class="col-3 my-n3 pe-0">
              @if (highlightedElement) {
                <app-navbar-details
                  [elementId]="highlightedElement.id"
                  [fullHeight]="parentElement.id === CatalogueRouteType.SYSTEMS"
                  [tag]="highlightedElement.tag"
                />
              }
            </div>
          }
        </div>
      </div>
    }
    </div>
    <div class="navbar-background" [class.menu-loaded]="showBg" (click)="onNavbarClose()"></div>
  </div>
</nav>

<ng-template
  #categoryMasonryItemOutlet
  let-el="el"
  let-currentUrlWithoutParams="currentUrlWithoutParams"
  let-navigationQueryParams="navigationQueryParams"
  let-highlightedElement="highlightedElement"
  let-elementUrl="elementUrl"
>
  <a
    class="d-flex align-items-center hover-color-primary mb-2 pe-2"
    [routerLink]="elementUrl"
    [queryParams]="navigationQueryParams"
    [class.color-black]="elementUrl !== currentUrlWithoutParams"
    (click)="onNavbarClose()"
    (mouseenter)="onMouseEnter(el)"
    (mouseleave)="onMouseLeave()"
  >
    <i
      class="icon icon-large me-1"
      [class]="[iconToCategoryMap[generateIdByCategoryPath(el.path)]]"
    ></i>
    <span class="ps-1 font-secondary">
      {{ el.isNameModified ? el.name : (el.name | titlecase) }}
    </span>
  </a>
  <div class="ms-3">
    @for (child of el.children; track child.id) {
      @let childUrl = `${elementUrl}/${child.slug}`;
      <a
        class="ps-4 mb-2 d-block hover-color-primary small pe-2"
        [class.color-black]="childUrl !== currentUrlWithoutParams"
        [routerLink]="childUrl"
        [queryParams]="navigationQueryParams"
        (click)="onNavbarClose()"
        [id]="child.id"
        (mouseenter)="onMouseEnter(child)"
        (mouseleave)="onMouseLeave()"
      >
        {{ child.isNameModified ? child.name : (child.name | titlecase) }}
      </a>
    }
  </div>
</ng-template>
